module.exports = __webpack_public_path__ + "7bb9446156604d2474ede2850c0ef164.svg";